import { render, staticRenderFns } from "./AboutDocument.vue?vue&type=template&id=a80ed892&scoped=true&"
import script from "./AboutDocument.vue?vue&type=script&lang=ts&"
export * from "./AboutDocument.vue?vue&type=script&lang=ts&"
import style0 from "./AboutDocument.vue?vue&type=style&index=0&id=a80ed892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ed892",
  null
  
)

export default component.exports